//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const ArrowUpLight = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="ArrowUpLight"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M8.47679 1.15778L12.7287 4.53726C13.0531 4.81732 13.0844 5.2652 12.8343 5.55941C12.5841 5.85362 12.08 5.90264 11.7752 5.66125L8.75029 3.25487L8.75029 14.2758C8.75029 14.6756 8.41418 15 7.99994 15C7.5857 15 7.2496 14.6756 7.2496 14.2758L7.2496 3.25487L4.2247 5.66125C3.91986 5.90264 3.42258 5.84795 3.16562 5.55941C2.90084 5.26144 2.9663 4.77771 3.27113 4.53726L7.52309 1.15778C7.84354 0.93808 8.16694 0.95694 8.47666 1.15778H8.47679Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
